<template>
  <custom-popup v-model="dialog" :cons="cons">
    <v-tabs v-model="computedTab" grow>
      <template v-for="(tab, i) in categories">
        <v-tab>{{ tab.name }}</v-tab>

        <v-tab-item>
          <v-divider class="mt-0" />

          <!--          <v-card-title>-->
          <!--            <v-switch v-model="allProducts" class="ma-0 pa-0" dense hide-details inset-->
          <!--                      label="ذخیره همه محصولات دسته‌بندی"/>-->
          <!--          </v-card-title>-->

          <v-row class="pa-2" no-gutters>
            <v-col
              v-for="(item, i) in tab.insurances"
              :key="i"
              class="pa-2"
              cols="12"
              md="4"
              sm="6"
            >
              <v-card class="rounded-xl" outlined>
                <v-list-item>
                  <v-list-item-avatar size="64">
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action v-if="!allProducts">
                    <v-simple-checkbox />
                  </v-list-item-action>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
      </template>
    </v-tabs>
  </custom-popup>
</template>

<script>
export default {
  name: "insuranceEditor",

  props: {
    value: Boolean,
    tabs: Number,
    categories: Array,
  },

  data() {
    return {
      cons: {
        title: "افزودن/ویرایش بیمه‌ها",
      },
      allProducts: true,
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedTab: {
      get() {
        return this.tabs;
      },
      set(val) {
        this.$emit("update:tabs", val);
      },
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
</style>
